import type { CSSProperties } from 'react';
import type { StepperConfig } from '@segmently/schema-models/v2';

function clampPercentage(value: number): number {
  return Math.min(Math.max(value, 0), 100);
}

export function getMediaContainerHeightPercentage(appearance: StepperConfig['appearance']): number {
  const legacyAppearance = appearance as (StepperConfig['appearance'] & { heightPercentage?: unknown }) | undefined;
  const rawValue = appearance?.dimensions?.heightPercentage ?? legacyAppearance?.heightPercentage;

  return typeof rawValue === 'number' && Number.isFinite(rawValue)
    ? clampPercentage(rawValue)
    : 50;
}

export function createContainerHeightStyle(heightPercentage: number): CSSProperties {
  return {
    flex: `0 0 ${heightPercentage}%`,
    height: `${heightPercentage}%`,
    minHeight: `${heightPercentage}%`,
    maxHeight: `${heightPercentage}%`,
  };
}
